export default __webpack_public_path__ + "static/media/avatar_137.3a1bb67b.png";